"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/button/style/css");

var _button = _interopRequireDefault(require("antd/es/button"));

require("antd/es/upload/style/css");

var _upload = _interopRequireDefault(require("antd/es/upload"));

require("antd/es/message/style/css");

var _message2 = _interopRequireDefault(require("antd/es/message"));

var _react = _interopRequireWildcard(require("react"));

require("./activity.scss");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

class ActivityImageUpload extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = {
      fileList: this.props.image ? [this.props.image] : new Array(),
      uploading: false
    };

    this.onRemove = file => {
      const {
        removeFile
      } = this.props;
      this.setState({
        fileList: []
      }, async () => {
        removeFile();
      });
    };

    this.beforeUpload = file => {
      const {
        uploadFile
      } = this.props;

      if (file.size <= 50000) {
        this.setState({
          fileList: [file]
        }, async () => {
          await uploadFile(file).then(() => {
            _message2.default.success('Uploaded successfully.');
          }).catch(err => {
            _message2.default.error(`Error uploading: ${err}`);
          });
        });
      } else {
        _message2.default.error('Upload failed. File exceeds 50KB limit.');
      }

      return false;
    };
  }

  render() {
    const {
      disabled
    } = this.props;
    const {
      fileList
    } = this.state;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "activity-image-upload"
    }, /*#__PURE__*/_react.default.createElement(_upload.default, {
      disabled: disabled,
      beforeUpload: this.beforeUpload,
      onRemove: this.onRemove,
      fileList: fileList,
      className: "upload-list-inline"
    }, /*#__PURE__*/_react.default.createElement(_button.default, {
      style: {
        whiteSpace: 'pre-wrap'
      }
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "fal fa-upload"
    }), ' ', "Upload")));
  }

}

var _default = ActivityImageUpload;
exports.default = _default;